<section class="page" data-testid="messages-provider-page">
  <app-page-header
    [hideBack]="isModal"
    title="Select a Provider"
    subtitle="Choose who you’d like to message"
    (back)="onCancel()">
  </app-page-header>

  <div class="page-content">
    <ng-container *ngrxLet="{ careTeam: careTeam$, isLoading: isLoading$ } as vm">
      @if (vm.isLoading) {
        <app-progress-spinner data-testid="messages-provider-spinner"></app-progress-spinner>
      } @else {
        <div class="list" data-testid="messages-provider-list">
          <div class="search">
            <app-icon name="search" size="sm" color="on-surface"></app-icon>
            <input
              #searchInput
              type="text"
              class="search-input"
              placeholder="Search providers"
              [value]="searchText()"
              (input)="searchText.set($any($event.target).value || '')"
              aria-label="Search providers" />
            @if (searchText().trim().length > 0) {
              <button type="button" class="clear-btn" aria-label="Clear search" (click)="onClearSearch(searchInput)">
                <app-icon name="close" size="sm" color="on-surface"></app-icon>
              </button>
            }
          </div>

          @if (!vm.careTeam || vm.careTeam.length === 0) {
            <div id="noCareTeamMembers" data-testid="messages-provider-empty" class="empty">
              <p>No care team members</p>
            </div>
          } @else {
            <div class="flex flex-col gap-10" role="radiogroup" aria-label="Providers">
              @for (careTeamMember of filterCareTeam(vm.careTeam); track careTeamMember.providerUserId) {
                <div
                  [attr.data-testid]="'messages-provider-row-' + careTeamMember.providerUserId"
                  class="row"
                  [class.is-selected]="selectedProviderUserId() === careTeamMember.providerUserId"
                  role="radio"
                  [attr.aria-checked]="selectedProviderUserId() === careTeamMember.providerUserId"
                  tabindex="0"
                  (click)="select(careTeamMember.providerUserId)"
                  (keydown)="onRowKeydown($event, careTeamMember.providerUserId)">
                  <div class="left">
                    <app-icon name="account_circle" size="xl" color="on-surface"></app-icon>
                  </div>

                  <div class="meta">
                    <div class="name">{{ careTeamMember.displayName }}</div>
                    <div class="sub">{{ getPrimaryTeamName(careTeamMember) }}</div>
                  </div>

                  <div class="right" aria-hidden="true">
                    @if (isMobileBrowser()) {
                      @if (selectedProviderUserId() === careTeamMember.providerUserId) {
                        <div class="check">
                          <app-icon name="check" size="sm" color="on-primary"></app-icon>
                        </div>
                      } @else {
                        <div class="radio"></div>
                      }
                    } @else {
                      <app-icon name="chevron_right" size="sm" color="on-surface-variant"></app-icon>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </ng-container>
  </div>

  @if (!isModal) {
    <footer class="page-footer">
      <button mat-stroked-button id="cancelBtn" type="button" class="error-btn" (click)="onCancel()">Cancel</button>
      <button
        type="submit"
        mat-flat-button
        class="primary-btn"
        data-testid="messages-provider-continue"
        [disabled]="!selectedProviderUserId()"
        (click)="onContinue()">
        Continue
      </button>
    </footer>
  }
</section>
